import { updateCloseButton } from "@mirage/service-fss-bridge";
import { isEmbedPage } from "@mirage/shared/util/tiny-utils";
import { useEffect, useRef } from "react";

export function useDIGModalDetection() {
  const wasModalOpen = useRef(false); // Tracks current state
  const hasModalEverOpened = useRef(false); // Tracks if open ever happened

  useEffect(() => {
    const checkModalState = () => {
      const isModalOpen = !!document.querySelector(".dig-Modal-content");

      if (isModalOpen && !wasModalOpen.current) {
        wasModalOpen.current = true;
        hasModalEverOpened.current = true;
        if (isEmbedPage()) {
          updateCloseButton(true);
        }
      } else if (!isModalOpen && wasModalOpen.current) {
        wasModalOpen.current = false;

        // Only call onClose if modal was ever opened
        if (hasModalEverOpened.current && isEmbedPage()) {
          updateCloseButton(false);
        }
      }
    };

    const observer = new MutationObserver(checkModalState);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Initial check in case modal is already present
    checkModalState();

    return () => observer.disconnect();
  }, []);
}
